export type Screen = { id: string; path: string; title: string; description: string };

// Sidebar order. E2b is a window of E2, not a menu item. E8-E10 are shown by role (lib/guard.ts). Hesabım (/account) is no menu item: the sidebar user line links to it.
export const screens: Screen[] = [
  { id: "E1", path: "/dashboard", title: "Durum Panosu", description: "Açık bulgular, izlenebilirlik ve kaynak durumu tek bakışta." },
  { id: "E2", path: "/sources", title: "Veri Kaynakları", description: "Dört sistemin dosyaları ve son versiyonları." },
  { id: "E3", path: "/reconciliation", title: "Mutabakat", description: "Kaynakları karşılaştırın, bulguları şiddete göre inceleyin." },
  { id: "E4", path: "/trace", title: "İzleme Zinciri", description: "Bir beyannameyi girişten ihracata kadar izleyin." },
  { id: "E5", path: "/ipa", title: "DİİB Paneli", description: "DİİB belgesi başına taahhüt ve gerçekleşme." },
  { id: "E6", path: "/history", title: "Veri Geçmişi", description: "Kayıt versiyonları ve yüklenen dosyaların bütünlüğü." },
  { id: "E7", path: "/report", title: "Denetim Raporu", description: "Denetim raporunu PDF olarak oluşturun ve indirin." },
  { id: "E8", path: "/audit-log", title: "Denetim Logu", description: "Kullanıcı işlemlerinin zaman sıralı kaydı." },
  { id: "E9", path: "/users", title: "Kullanıcılar", description: "Kullanıcı açma, rol, pasifleştirme ve parola sıfırlama." },
  { id: "E10", path: "/settings", title: "Ayarlar", description: "Geçerli ayar sürümü. Değişiklik ayar dosyasından yapılır." },
];

export const pathOf = (id: string) => screens.find((s) => s.id === id)!.path;

/** Old /e1../e8 addresses (bookmarks) → new path; null for any other path. */
export const legacyRedirect = (path: string): string | null => {
  const m = /^\/e([1-8])$/.exec(path);
  return m ? pathOf(`E${m[1]}`) : null;
};

/** Hesabım: bütün roller, menü öğesi değil (ui.md §4.5). */
export const ACCOUNT = "/account";

export const defaultPath = screens[0]!.path;

/** `/sources/uploads/:id` (E2 Yükleme detayı, menü öğesi değil): undefined = bu desen değil, null = :id sayı değil. */
export const uploadIdOf = (path: string): number | null | undefined => {
  const m = /^\/sources\/uploads\/([^/]+)$/.exec(path);
  return m ? (/^\d{1,15}$/.test(m[1]!) ? Number(m[1]) : null) : undefined;
};
